module.exports = __webpack_public_path__ + "./fonts/SF-Pro-Rounded-Bold.otf";